export const LEADS_MODAL = '/solleads/get-leads-modal'
